import { useParams, Link } from 'react-router-dom';
import { categories, videos } from '@/mocks/videos';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SeoHead from '@/components/feature/SeoHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import VideoCard from '@/components/base/VideoCard';
import { siteInfo } from '@/mocks/site';
import { useState } from 'react';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryVideos = videos.filter((v) => v.category === slug);
  const [activeCategory, setActiveCategory] = useState(slug || categories[0].slug);

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-16">
          <div className="w-full px-4 md:px-6 py-20 text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-950 mb-4">分类未找到</h1>
            <Link to="/" className="text-primary-600 hover:text-primary-700 text-sm cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const currentVideos = videos.filter((v) => v.category === activeCategory);

  return (
    <>
      <ScrollToTop />
      <SeoHead
        title={`${category.name} - 国产在线观看高清${category.name}免费在线观看`}
        description={`${category.description}，国产在线观看平台提供海量高清${category.name}免费在线观看，每日更新最新内容。`}
        keywords={`国产在线观看,${category.name}在线观看,高清${category.name},免费${category.name}`}
        canonicalUrl={`${siteInfo.url}/category/${category.slug}`}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: siteInfo.url },
            { '@type': 'ListItem', position: 2, name: category.name },
          ],
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${category.name} - 国产在线观看`,
          description: category.description,
          url: `${siteInfo.url}/category/${category.slug}`,
        }}
      />

      <Navbar />
      <main className="min-h-screen pt-16">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: category.name },
              ]}
            />

            <div className="mb-8">
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
                <i className={`${category.icon} mr-2 text-primary-600`}></i>
                {category.name}
              </h1>
              <p className="text-sm text-foreground-500">{category.description}</p>
            </div>

            <div className="flex items-center gap-2 mb-8 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  onClick={() => setActiveCategory(cat.slug)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    activeCategory === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5 mb-14" data-product-shop="">
              {currentVideos.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}